/**
 * Mobile Module
 * Mobile-specific features like sidebar tabs and mobile click handlers
 */

import { isMobile, isTab } from "./utils.js";

export function initMobileClick() {
  if (isMobile()) {
    const cardMobiles = document.querySelectorAll('.cardLang');

    cardMobiles.forEach(card => {
      const triggerMobile = card.querySelector('.cardLang__header');

      if (triggerMobile) {
        card.removeEventListener('mouseenter', this.hoverHandler);
        card.removeEventListener('mouseleave', this.hoverHandler);

        triggerMobile.addEventListener('click', () => {
          card.classList.toggle('active');
        });
      }
    });
  }
}

export function initMobileSidebarTabs() {
  if (!isMobile()) return;

  const dropdowns = document.querySelectorAll(".dropdown-container ul");

  dropdowns.forEach((dropdown) => {
    const firstLi = dropdown.querySelector("li:first-child");
    if (!firstLi) return;

    const firstLink = firstLi.querySelector("a");
    if (!firstLink) return;

    const headerLi = firstLi.cloneNode(true);
    headerLi.classList.add("dropdown-header");
    dropdown.insertBefore(headerLi, firstLi);

    const allLinks = dropdown.querySelectorAll(
      "li:not(.dropdown-header):not(:first-child) a"
    );

    headerLi.addEventListener("click", (e) => {
      e.preventDefault();
      toggleDropdown(dropdowns, dropdown);
    });

    allLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        selectDropdownItem(dropdown, link, headerLi.querySelector("a"));
      });
    });
  });

  setupGlobalListeners(dropdowns);
}

function toggleDropdown(dropdowns, currentDropdown) {
  dropdowns.forEach((dropdown) => {
    if (dropdown !== currentDropdown) {
      dropdown.classList.remove("open");
    }
  });
  currentDropdown.classList.toggle("open");
}

function selectDropdownItem(dropdown, selectedLink, headerLink) {
  dropdown.querySelectorAll("a").forEach((a) => {
    a.classList.remove("active");
    a.setAttribute("aria-selected", "false");
  });

  selectedLink.classList.add("active");
  selectedLink.setAttribute("aria-selected", "true");

  headerLink.textContent = selectedLink.textContent.trim();
  headerLink.setAttribute("href", selectedLink.getAttribute("href"));
  headerLink.setAttribute(
    "data-tabby",
    selectedLink.getAttribute("data-tabby")
  );

  dropdown.classList.remove("open");

  console.log("Selected:", selectedLink.textContent.trim());
}

function setupGlobalListeners(dropdowns) {
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".dropdown-container")) {
      dropdowns.forEach((dropdown) => dropdown.classList.remove("open"));
    }
  });
}

export function initScrollHeader() {
  const header = document.querySelector(".headerBasic");

  if (!header) {
    console.warn("Header element not found");
    return;
  }

  const handleScroll = () => {
    if (window.scrollY > 0) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  };

  handleScroll();
  window.addEventListener("scroll", handleScroll, { passive: true });
}
